<!--键值对展示组件-->
<template>
	<div class="columnsContentBody" :style="getBackgroudImageStyle('/userPowerUnit/unitborder.png')">
		<img :src="getLeftImage">
		<p class="columns columns-bian" >{{columns}}</p>
		<p class="content" @click="$emit('onClick')">{{content}}</p>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
		},
		props: ["img", "columns","content"],
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getLeftImage(){
				return resourcesStore.getters.getResourcesByName('userPowerUnit/'+this.img+'.png')
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.columnsContentBody{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.columns{
		font-size: 14px;
		margin-right: 95px;
		width: 20%;
		color: #75ecf7;
	}
	.content{
		font-size: 14px;
		cursor: pointer;
	}
	.columnsContentBody img{
		margin-left: 8%;
		margin-right: 10px;
		width: 15px;
		height: 15px;
		padding: 2px 0px;
		margin-top: 1px;
		margin-bottom: 5px;
	}
</style>